module.exports = __webpack_public_path__ + "static/pistola_final_1-35154dab3cf8995312374bdb7f871d88.png";